// extracted by mini-css-extract-plugin
export default {"modal-overlay":"modal-component_modal-overlay__40yv6","modal-content":"modal-component_modal-content__HI-FJ","modal-close":"modal-component_modal-close__aqb4o"};